export const CSV_COLUMNS = [
    "id", "title", "storeaddress", "storeaddressurl", "time",
    "state", "suburb", "longitude", "latitude", "tags",
];
export const ALLOWED_STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA", "International"];
function norm(v) {
    // Normalize line endings (CSV from Windows may have \r\n, /list returns \n).
    return (v ?? "").replace(/\r\n?/g, "\n").trim();
}
function normTags(v) {
    return norm(v).split("|").map(s => s.trim()).filter(Boolean).sort().join("|");
}
// time is rich-text; user might write blank lines / trailing spaces. Treat any
// whitespace-only diff as equivalent.
function normTime(v) {
    return norm(v).split(/\n+/).map(s => s.trim()).filter(Boolean).join("\n");
}
export function computeDiff(csvRows, currentRows) {
    const out = { create: [], update: [], unchanged: [], missing: [], invalid: [] };
    const byId = new Map();
    for (const r of currentRows)
        if (r.id)
            byId.set(r.id, r);
    const seenIds = new Set();
    for (const row of csvRows) {
        const problems = [];
        if (!norm(row.title))
            problems.push("title is empty");
        if (norm(row.state) && !ALLOWED_STATES.includes(norm(row.state))) {
            problems.push(`state "${row.state}" is not one of ${ALLOWED_STATES.join("/")}`);
        }
        for (const f of ["longitude", "latitude"]) {
            const v = norm(row[f]);
            if (v && Number.isNaN(parseFloat(v)))
                problems.push(`${f} "${v}" is not a number`);
        }
        if (problems.length) {
            out.invalid.push({ csv: row, reasons: problems });
            continue;
        }
        const id = norm(row.id);
        if (!id) {
            out.create.push({ csv: row, changedKeys: [] });
            continue;
        }
        seenIds.add(id);
        const cur = byId.get(id);
        if (!cur) {
            out.create.push({ csv: row, changedKeys: [] });
            continue;
        }
        const changedKeys = [];
        for (const k of CSV_COLUMNS) {
            if (k === "id")
                continue;
            const nf = k === "tags" ? normTags : k === "time" ? normTime : norm;
            if (nf(row[k]) !== nf(cur[k]))
                changedKeys.push(k);
        }
        (changedKeys.length ? out.update : out.unchanged).push({ csv: row, current: cur, changedKeys });
    }
    for (const cur of currentRows) {
        if (cur.id && !seenIds.has(cur.id))
            out.missing.push(cur);
    }
    return out;
}
